import { apiService } from "./api";

export const authService = {
  login: async (email, password) => {
    const response = await apiService.post("/auth/login", { email, password });

    if (response.status && response.data && response.data.token) {
      localStorage.setItem("token", response.data.token);

      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("userId", response.data.user.id);
      localStorage.setItem("userRole", response.data.user.role);
      localStorage.setItem("userName", response.data.user.name);
      localStorage.setItem("userEmail", response.data.user.email);
      localStorage.setItem("mobileNumber", response.data.user.mobileNumber);
      localStorage.setItem("companyId", response.data.user.companyId);
    }

    return response;
  },

  // Get user profile
  getProfile: async () => {
    const response = await apiService.get("/auth/profile");

    if (response.status && response.data) {
      localStorage.setItem("userName", response.data.name || "");
      localStorage.setItem("userEmail", response.data.email || "");
      localStorage.setItem("mobileNumber", response.data.mobileNumber || "");
      localStorage.setItem("userRole", response.data.role || "user");
      localStorage.setItem("companyId", response.data.companyId);
    }

    return response;
  },

  // Logout user
  logout: () => {
    const itemsToRemove = [
      "token",
      "isAuthenticated",
      "userId",
      "userRole",
      "mobileNumber",
      "userName",
      "userEmail",
      "companyId",
    ];

    itemsToRemove.forEach((item) => localStorage.removeItem(item));

    window.location.href = "/login";
  },

  isAuthenticated: () => {
    const token = localStorage.getItem("token");
    return !!token && localStorage.getItem("isAuthenticated") === "true";
  },

  getCurrentUser: () => {
    if (!authService.isAuthenticated()) return null;

    return {
      id: localStorage.getItem("userId"),
      name: localStorage.getItem("userName"),
      email: localStorage.getItem("userEmail"),
      mobileNumber: localStorage.getItem("mobileNumber"),
      role: localStorage.getItem("userRole"),
      companyId: localStorage.getItem("companyId"),
      token: localStorage.getItem("token"),
    };
  },

  getAuthHeaders: () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  },

  isSuperAdmin: () => {
    return localStorage.getItem("userRole") === "super_admin";
  },

  isAdminOrSuperAdmin: () => {
    const role = localStorage.getItem("userRole");
    return role === "admin" || role === "super_admin";
  },
};

export default authService;
